module.exports = {
	"name": "webappv2",
	"version": "3.25.0",
	"description": "Webapp v2",
	"main": "src/index.js",
	"engines": {
		"node": "=10.22.X"
	},
	"scripts": {
		"dev": "webpack-dev-server --progress --branch=local-dev --ip=$(ifconfig | grep -m2 'inet ' | grep -Fv 127.0.0.1 | sed -E 's/.*[[:space:]]+([[:digit:]]{1,3}\\.[[:digit:]]{1,3}\\.[[:digit:]]{1,3}\\.[[:digit:]]{1,3})[[:space:]].+/\\1/')",
		"client-setup": "node ./scripts/clientSetup/index.js --interactive",
		"release": "node ./bin/.release_creator",
		"prestart": "yarn install",
		"start": "webpack-dev-server --progress --branch=local-dev",
		"open-chrome-macos": "open -n -a /Applications/Google\\ Chrome.app --args --user-data-dir=\"$HOME/.chrome_dev_test\" --disable-web-security http://$(ipconfig getifaddr en0):8080",
		"open-edge-macos": "open -n -a /Applications/Microsoft\\ Edge.app --args --user-data-dir=\"$HOME/.edge_dev_test\" --disable-web-security http://$(ipconfig getifaddr en0):8080",
		"build": "cross-env NODE_ENV=production webpack --progress",
		"test": "nyc --reporter=html --reporter=text mocha --compilers js:babel-register",
		"test-debug": "mocha --debug-brk --compilers js:babel-register",
		"test:watch": "mocha --compilers js:babel-register --watch",
		"prettier-fix-all": "prettier --write .",
		"prettier-check-all": "prettier --check .",
		"eslint": "npx eslint .",
		"prune-branches": "./scripts/prune.sh",
		"postinstall": "lefthook install"
	},
	"keywords": [
		"Twipe",
		"Replica",
		"POC"
	],
	"author": "Gaël Gillard <gael.gillard@twipemobile.com>",
	"license": "Copyright Twipemobile",
	"dependencies": {
		"@babel/polyfill": "7.4.4",
		"cropperjs": "1.5.9",
		"crypto-js": "3.1.9-1",
		"dotdotdot": "1.7.0",
		"dustjs-helpers": "1.7.3",
		"dustjs-linkedin": "2.7.2",
		"es6-event-emitter": "1.5.2",
		"es6-promise": "4.0.5",
		"hammerjs": "2.0.8",
		"history": "4.2.0",
		"jquery": "3.1.1",
		"jsonfile": "4.0.0",
		"jsonwebtoken": "8.5.1",
		"lodash.throttle": "4.1.1",
		"mixpanel-browser": "2.41.0",
		"mobile-detect": "1.3.5",
		"modernizr": "3.3.1",
		"moment": "2.17.1",
		"node-sass": "4.14.1",
		"normalizecss": "3.0.0",
		"nouislider": "9.2.0",
		"pdfjs-old": "npm:pdfjs-dist@1.10.97",
		"pdfjs-new": "npm:pdfjs-dist@2.15.349",
		"recursive-copy": "2.0.11",
		"remove-accents": "0.4.2",
		"rewire": "5.0.0",
		"swiper": "3.4.1",
		"whatwg-fetch": "2.0.2"
	},
	"devDependencies": {
		"autoprefixer": "6.6.1",
		"babel-eslint": "7.1.1",
		"babel-loader": "6.2.10",
		"babel-plugin-transform-class-properties": "6.22.0",
		"babel-plugin-transform-object-rest-spread": "6.22.0",
		"babel-plugin-transform-runtime": "6.23.0",
		"babel-preset-es2015": "6.22.0",
		"babel-preset-es2017": "6.24.1",
		"babel-register": "6.22.0",
		"chai": "4.3.4",
		"chai-as-promised": "7.1.1",
		"copy-webpack-plugin": "4.0.1",
		"cross-env": "3.1.4",
		"css-loader": "0.26.1",
		"dustjs-linkedin-loader": "0.0.4",
		"ejs": "2.5.6",
		"eslint": "3.17.1",
		"eslint-config-prettier": "8.3.0",
		"eslint-plugin-import": "2.2.0",
		"exports-loader": "0.6.3",
		"extract-text-webpack-plugin": "1.0.1",
		"faker": "5.5.3",
		"fetch-mock": "5.8.1",
		"file-loader": "0.9.0",
		"git-revision-webpack-plugin": "2.5.1",
		"html-webpack-plugin": "3.2.0",
		"ifdef-loader": "1.0.3",
		"imports-loader": "0.7.0",
		"inquirer": "3.0.6",
		"jsdom": "16.4.0",
		"jsdom-global": "3.0.2",
		"json-loader": "0.5.4",
		"lefthook": "1.5.0",
		"mocha": "3.2.0",
		"mocked-env": "1.3.2",
		"modernizr-loader": "1.0.1",
		"node-sass": "4.14.1",
		"nodegit": "0.27.0",
		"nyc": "15.1.0",
		"optimist": "0.6.1",
		"optimize-css-assets-webpack-plugin": "1.3.0",
		"postcss-loader": "1.2.2",
		"prettier": "2.4.1",
		"querystring": "0.2.0",
		"sass-loader": "4.1.1",
		"semver": "5.3.0",
		"sinon": "10.0.0",
		"sinon-chai": "3.7.0",
		"style-loader": "0.13.1",
		"webpack": "1.14.0",
		"webpack-cleanup-plugin": "0.4.1",
		"webpack-dashboard": "0.2.1",
		"webpack-dev-server": "1.16.2",
		"write-file-webpack-plugin": "3.4.2"
	},
	"nyc": {
		"include": [
			"src/**/*.js",
			"src/**/**/*.js",
			"src/**/**/**/*.js",
			"src/common/appState.js",
			"src/common/utilities/utils.js"
		],
		"exclude": [
			"src/common/*.js",
			"src/web/reader/vendors/*.js",
			"src/web-include/**",
			"**/node_modules/**",
			"**/test/**",
			"**/coverage/**"
		],
		"all": true
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 456
// module chunks = 0 1